import script from "./DefaultPlanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultPlanModal.vue?vue&type=script&setup=true&lang=js"

import "./DefaultPlanModal.vue?vue&type=style&index=0&id=5b42ca9a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b42ca9a"]])

export default __exports__